import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table } from "../../../features/Table";
import { type D1PdfPageSelection, columns } from "./columns";
import {
  type FilterD1PdfPageSelectionSchema,
  D1PdfPageSelectionFilter,
} from "./filter";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const D1PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("tables");
  const client = searchParams.get("client") || Clients.D1;

  return (
    <Table<D1PdfPageSelection, FilterD1PdfPageSelectionSchema>
      label={t("d1_pdf_page_selection.title", { defaultValue: "PDF page selection" })}
      client={client}
      table_name={Tables.D1_PDF_PAGE_SELECTION}
      columns={columns}
      filter={<D1PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${Tables.D1_PDF_PAGE_SELECTION}/new`,
        },
      ]}
    />
  );
};
